import { render, staticRenderFns } from "./MultiSimpleKeyboard.vue?vue&type=template&id=4cdd0348&scoped=true&"
import script from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./MultiSimpleKeyboard.vue?vue&type=style&index=0&id=4cdd0348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd0348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
